import { HttpClient, JSON_STRING, MHTTPCL } from "../../../services/http/http-client";
import { CONTACTS_URL } from "./contacts.service";

export const CONTACT_IMPORT_EXPORT_SECTION = 'import_export';

export const ContactIMEXService = {
    getSearch: (search) => HttpClient.get(CONTACTS_URL, {
        section: CONTACT_IMPORT_EXPORT_SECTION,
        action: "merge_contact_fulltextsearch",
        search
    }),

    getFieldSearch: (field) => HttpClient.get(CONTACTS_URL, {
        section: CONTACT_IMPORT_EXPORT_SECTION,
        action: "double_contact_search",
        field
    }),

    getMergeModalData: (contact_ids) => MHTTPCL.post(CONTACTS_URL, {
        section: CONTACT_IMPORT_EXPORT_SECTION,
        action: "open_contact_merge_modal",
        contact_ids,
    }),

    finishContactMerge: (mergedcontactid, deleteablecontactid) => HttpClient.post(CONTACTS_URL, {
        section: CONTACT_IMPORT_EXPORT_SECTION,
        action: "finish_merge_contact_task",
        mergedcontactid,
        deleteablecontactid
    }),

    getExportContactsExcel: () => HttpClient.get(CONTACTS_URL, {
        section: CONTACT_IMPORT_EXPORT_SECTION,
        action: "export_contacts",
        format: "xlsx",
        mime_type: "application/excel"
    }, {
        responseType: 'blob'
    }),

    importContactCSV: (formData) => HttpClient.postFormData(CONTACTS_URL, formData)



}